import { connect } from 'react-redux';
import * as Actions from '../../store/orders/import/orders.import.actions';
import { OrderImportMappingsDeleteModal } from '../../components/modals/order-import-mappings-delete-modal';

const mapDispatchToProps = (dispatch) => {
  return {
    deleteSavedMapping: (savedMappingName) => {
      dispatch(Actions.deleteSavedMapping(savedMappingName));
    },
  };
};

export const OrderImportMappingsDeleteModalContainer = connect(null, mapDispatchToProps)(OrderImportMappingsDeleteModal);
